import { useEffect } from "react";

const useScrollMount = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])
}

export default useScrollMount